import { Injectable } from '@angular/core';
import {Subject} from "rxjs";
import {SupportDetailDto} from "../models/support.models";
import {FormSelectModelDto} from "../../payment-link-list/models/paylinks.model";

@Injectable({
  providedIn: 'root'
})
export class SupportDetailUpdateService {

  selectedSupportItem$: Subject<SupportDetailDto> = new Subject<SupportDetailDto>()
  supportStatusSelected$: Subject<FormSelectModelDto | undefined> = new Subject<FormSelectModelDto | undefined>()
  supportTypeSelected$: Subject<FormSelectModelDto | undefined> = new Subject<FormSelectModelDto | undefined>()

  constructor() { }
}
